<template>
  <div>
    <el-form ref="form" size="small" :model="formData" :rules="rules">
      <el-row :gutter="10" class="mb-2">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_carNumberPlate') || '车牌号'"
            prop="carNumberPlate"
          >
            <el-input
              v-model="formData.carNumberPlate"
              :placeholder="$l('INDEX.tips_input_placeholder')"
              clearable
              maxlength="50"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_vehicleModel') || '车型'"
            prop="vehicleModel"
          >
            <el-input
              v-model="formData.vehicleModel"
              :placeholder="$l('INDEX.tips_input_placeholder')"
              clearable
              maxlength="50"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <OrderTable
            ref="orderTable"
            :hxJdVehicleCode="hxJdVehicleCode"
            :hxShipmentJdCode="hxShipmentJdCode"
          />
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import OrderTable from './order-table'
export default {
  mixins: [EditLoading],
  components: { OrderTable },
  props: {
    hxJdVehicleCode: { type: String, default: '' },
    hxShipmentJdCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      rules: {
        carNumberPlate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder'),
            trigger: 'blur',
          },
        ],
        vehicleModel: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder'),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.hxJdVehicleCode) return
      const res = await this.$api
        .ecomHxShipmentJdVehicleDetailApi({
          hxJdVehicleCode: this.hxJdVehicleCode,
        })
        .catch(() => null)
      this.formData = res?.body || {}
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      const orders = this.$refs.orderTable.getCheckboxRecords()
      const listHxJdOrderCode = orders?.map((item) => item.hxJdOrderCode) || []
      const params = {
        ...this.formData,
        listHxJdOrderCode,
        hxJdVehicleCode: this.hxJdVehicleCode,
        hxShipmentJdCode: this.hxShipmentJdCode,
      }

      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomHxShipmentJdVehicleSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
